<script>
	import Tabs from "../../../components/Tabs/Tabs.svelte";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { Row, Col } from "sveltestrap";
	import PendingFilterForm from "./Pending/PendingFilterForm.svelte";
	import PendingValidationTable from "./Pending/PendingValidationTable.svelte";
	import ReviewedValidationTable from "./Reviewed/ReviewedValidationTable.svelte";
	import ReviewedFilterForm from "./Reviewed/ReviewedFilterForm.svelte";
	import { navigate } from "svelte-routing";
	import queryString from "query-string";
	import {
		arrayToQueryParams,
		extractErrorMessage,
		queryArrStrToNum,
	} from "src/utils/misc";
	import client from "src/services/client";
	import { onMount } from "svelte";
	import {
		damageReviewed,
		errorMessage,
		initPage,
		loading,
		sizeSelect,
		totalPages,
		totalRecords,
	} from "src/store/store";

	let items = [
		{
			label: "Pending",
			value: 1,
		},
		{
			label: "Reviewed",
			value: 2,
		},
	];

	let err;
	let activeTab = 1;
	let query = queryString.parse(window.location.search);
	let pendingData = [];
	let concludedData = [];
	let hasMounted = false;

	let pageParams = {
		pageSize: 20,
		pageNumber: $initPage,
	};

	let concludedParams = {
		...pageParams,
		...query,
		tab: 2,
	};
	let pendingParams = {
		...pageParams,
		...query,
		tab: 1,
	};

	$: activeTab = query.tab ? parseInt(query.tab) : 1;

	$: filtersAreApplied = Object.entries(activeTab === 1 ? pendingParams : concludedParams)
		.filter(([key]) => !["pageSize", "pageNumber", "tab"].includes(key))
		.some(([, v]) => {
			if (Array.isArray(v)) return v.length > 0;
			return v !== undefined && v !== null && v !== "";
	});

	async function changeTab(index) {
		activeTab = index;
		navigate(`/issues/damage-validation?tab=${index}`);
		if (index === 1) {
			damageReviewed.set(false);
			changePendingParams("");
		} else {
			damageReviewed.set(true);
			changeConludedParams("");
		}
	}

	function changePendingParams(params) {
		if (params === "") {
			pendingParams = {
				pageSize: 20,
				pageNumber: 1,
				tab: 1,
			};
			initPage.set(1);
			fetchPendingReviews(pendingParams);
			return;
		} else if (params) {
			let newParams = { ...pendingParams, ...params };
			for (let key in newParams) {
				if (
					(Array.isArray(newParams[key]) &&
						newParams[key].length === 0) ||
					newParams[key] === ""
				) {
					delete newParams[key];
				}
			}

			pendingParams = newParams;
			fetchPendingReviews(pendingParams);
		}
	}

	async function fetchPendingReviews(params) {
		try {
			if (!params) {
				params = queryString.parse(window.location.search);
			}
			params.pageSize = $sizeSelect;
			loading.set(true);
			const res = await client(`/v1/DamageValidation/pendingReviewList`, {
				method: "GET",
				version: "Tasking",
				params: params,
			});
			let queryReq = queryString.stringify(params);
			navigate(`/issues/damage-validation?` + queryReq);
			if (res.status === 200) {
				pendingData = res.data.data;
				totalRecords.set(res.data.totalCount);
				totalPages.set(res.data.totalPage);
				initPage.set(res.data.pageNumber);
				loading.set(false);
				pendingParams = params;
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
			loading.set(false);
		}
	}

	function changeConludedParams(params = {}) {
		if (params === "") {
			concludedParams = {
				pageSize: 20,
				pageNumber: 1,
				tab: 2,
			};
			initPage.set(1);
			fetchConludedReview(concludedParams);
			return;
		} else if (params) {
			let newParams = { ...concludedParams, ...params };
			for (let key in newParams) {
				if (
					(Array.isArray(newParams[key]) &&
						newParams[key].length === 0) ||
					newParams[key] === ""
				) {
					delete newParams[key];
				}
			}
			concludedParams = newParams;
			fetchConludedReview(concludedParams);
		}
	}

	async function fetchConludedReview(params) {
		try {
			if (!params) {
				params = queryString.parse(window.location.search);
				if (params.verdict) {
					params.verdict = queryArrStrToNum(params.verdict);
				}
			}
			params.pageSize = $sizeSelect;
			loading.set(true);
			const res = await client(
				`/v1/damageValidation/concludedReviewList`,
				{
					method: "GET",
					version: "Tasking",
					params: params,
				}
			);
			let queryNav = queryString.stringify(arrayToQueryParams(params));
			navigate(`/issues/damage-validation?` + queryNav);
			if (res.status === 200) {
				concludedData = res.data.data;
				totalRecords.set(res.data.totalCount);
				totalPages.set(res.data.totalPage);
				initPage.set(res.data.pageNumber);
				loading.set(false);
				concludedParams = params;
			}
		} catch (error) {
			console.log(error);
			extractErrorMessage(error);
			loading.set(false);
		}
	}

	async function handleDebounceSearch(e) {
		if (e !== "") {
			try {
				if (!e || e.trim() === "") {
					throw new Error("Vehicle no cannot be null or whitespace.");
				}
				if (e.length <= 2 || e.length >= 20) {
					throw new Error(
						"Vehicle no must be between 3 and 19 characters."
					);
				}
				if (!/^[a-zA-Z0-9]+$/.test(e)) {
					throw new Error("Vehicle no must be alphanumeric.");
				}
				let carRes = await client(`/v1/plateNumbers/${e}?limit=100`, {
					method: "GET",
					version: "Vehicle",
				});
				let carOptions = carRes.data.map((car) => {
					return {
						value: car.vehicleId,
						label: car.plateNo,
					};
				});
				return carOptions;
			} catch (error) {
				console.log(error);
				extractErrorMessage(error);
				return [];
			}
		}
	}

	async function fetchPendingOrConcluded() {
		if (activeTab === 1) {
			await fetchPendingReviews();
		} else {
			await fetchConludedReview();
		}
	}

	onMount(async () => {
		damageReviewed.set(false);
		await fetchPendingOrConcluded();
	});

	sizeSelect.subscribe((value) => {
		if (!hasMounted) {
			hasMounted = true;
			return;
		} else {
			pendingParams.pageSize = value;
			concludedParams.pageSize = value;
			fetchPendingOrConcluded();
		}
	});

	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={err} />
			<Row>
				<Col>
					<PageHeader title="Damage Validation" />
				</Col>
			</Row>
			<Row>
				<Col>
					<Tabs {items} {activeTab} fetch={changeTab} />
				</Col>
			</Row>
			<Row>
				{#if activeTab === 1}
					<PendingFilterForm
						changeSearchParams={changePendingParams}
						params={pendingParams}
						handleVehicleSearch={handleDebounceSearch}
					/>
				{:else}
					<ReviewedFilterForm
						changeSearchParams={changeConludedParams}
						params={concludedParams}
						handleVehicleSearch={handleDebounceSearch}
					/>
				{/if}
			</Row>
		</div>
	</Col>
	<Col>
		{#if activeTab === 1}
			<PendingValidationTable
				data={pendingData}
				handleSort={changePendingParams}
				{filtersAreApplied}
			/>
		{:else}
			<ReviewedValidationTable
				data={concludedData}
				handleSort={changeConludedParams}
				{filtersAreApplied}
			/>
		{/if}
	</Col>
</Row>
